import { IntlProvider } from 'app/shared/providers/intl-provider';
import { AppRouter } from 'app/components/router';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from 'app/shared/contexts/api';
import { BuildingProvider } from 'app/shared/contexts/building';
import { UserProvider } from 'app/shared/contexts/user';
import { FeatureFlagsProvider } from 'app/shared/contexts/feature-flags';
import { ThemeProvider } from 'app/shared/contexts/theme';
import { MiniappSdkProvider } from 'app/shared/contexts/miniapp-sdk';
import { HostInfoProvider } from 'app/shared/contexts/host-info';
import { FeedbackProvider } from 'app/shared/contexts/feedback';
import { QueryClientProvider } from 'app/shared/providers/query-client-provider';
import { EntityIconProvider } from 'app/shared/providers/entity-icon-provider';
import { ErrorsProvider } from 'app/shared/contexts/errors';
import { TokenRefreshManager } from 'app/components/token-refresh-manager';
import { POSITION, ToastProvider } from '@hqo/toast';
import '../index.css';

export const App = (): JSX.Element => (
  <ErrorsProvider>
    <QueryClientProvider>
      <BrowserRouter>
        <ApiProvider>
          {/* Inside ApiProvider for the credentials, inside QueryClientProvider for the lookup. */}
          <EntityIconProvider>
            <MiniappSdkProvider>
              <TokenRefreshManager />
              <HostInfoProvider>
                <UserProvider>
                  <IntlProvider>
                    <BuildingProvider>
                      <ThemeProvider>
                        <FeatureFlagsProvider>
                          <FeedbackProvider>
                            <AppRouter />
                            {/* One container for the whole app — `toast.*` calls have nowhere to render
                              without it. Inside the intl/theme providers so a toast can carry
                              localized copy and the design system's colours. Bottom-centre so a toast
                              does not sit over the page title and read as a push notification.

                              `useSonnerToasts` is what the admin surfaces run: it renders the HqO
                              styling — lucide icon, system-pink tokens, no progress bar — where the
                              package's react-toastify default is the pre-migration look. */}
                            <ToastProvider useSonnerToasts position={POSITION.BOTTOM_CENTER} />
                          </FeedbackProvider>
                        </FeatureFlagsProvider>
                      </ThemeProvider>
                    </BuildingProvider>
                  </IntlProvider>
                </UserProvider>
              </HostInfoProvider>
            </MiniappSdkProvider>
          </EntityIconProvider>
        </ApiProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ErrorsProvider>
);
